
import OverviewBox from '@/components/overview/OverviewBox.vue'
import { ICategoriesBoxData } from '@/__types__/overview'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'CategoriesBox',
  props: {
    data: {
      type: Object as PropType<ICategoriesBoxData>,
      required: true,
    },
  },
  components: { OverviewBox },
})
